import AppConstants from '../constants/AppConstants';
import { AxiosBillingClient } from '../proxy/ProxyClients';

// const api = new Client(AppConstants.BASE_API_URL, configureAxios());

const InvoicesService = {
  findInvoices: (year: number, month: number) => AxiosBillingClient.get({ year, month }).then((response) => response)
};

export default InvoicesService;
